import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
  FetchPolicy,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type {
  SaveCouponPayload,
  SaveCouponResult,
  SaveCouponVariables,
} from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<SaveCouponVariables, SaveCouponPayload | null>) {
  const { variables } = params;

  const {
    locator,
    id,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid } = descriptor;

  const search = {
    cid,
    uid,
    id,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/Coupon/SaveCouponStringForSignup${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}


function ccPayloadFactory(params: RequestFactoryContext<SaveCouponVariables, SaveCouponPayload | null>) {
  const { data } = params;
  return data;
}

export const fetchRequestContract = createRequestContract<
  SaveCouponVariables,
  SaveCouponPayload | null
>({
  schema,
  dataPath: 'user:customer:save_coupon_string_for_signup',
  verb: requestVerbs.PATCH,
  fetchPolicy: FetchPolicy.NetworkOnly,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,
  payloadFactoryFn: ccPayloadFactory,

  parentKeySelector: variables => variables.locator.descriptor.cid,
});

export const fetchResponseContract = createResponseContract<
  SaveCouponVariables,
  SaveCouponPayload | null,
  SaveCouponResult,
  SaveCouponResult[],
  SaveCouponResult[]
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,

  keySelector: coupon => coupon.couponString,
  processorFn: response => response,
});
